<template>
    <transition name="fade" appear>
        <div v-show="loaded" class='wrapper'>
            <div class='title'>
                <router-link :to="{ name: 'Home'}">Recipes</router-link> / {{ recipe.title }}
            </div>
            <div class='details'>
                <div class='author'><img alt="author" src="../assets/person-black-18dp.svg">{{ recipe.author }}</div>
                <div class='views'>{{ formatViews(recipe.views) }}</div>
            </div>
            <div class='image'>
                <picture>
                    <source :srcset="webp" type="image/webp">
                    <source :srcset="jpeg" type="image/jpeg">
                    <img :src="jpeg" :alt="recipe.description">
                </picture>
            </div>
            <section role="main">
                <div class='story'>
                    {{ recipe.story }}
                </div>
                <div class='ingredients'>
                    <div class='heading'>Ingredients</div>
                    <div v-for="component in recipe.components" v-bind:key="component.name">
                        <div class='component'>{{ component.name }}</div>
                        <ul class='ingredient-list'>
                            <li v-for="ingredient in component.ingredients" v-bind:key="ingredient.name">
                                {{ ingredient }}
                            </li>
                        </ul>
                    </div>
                </div>
                <div class='method'>
                    <div class='heading'>Method</div>
                    <ul class='steps'>
                        <li v-for="(step,index) in recipe.method" v-bind:key="index">
                            {{ step }}
                        </li>
                    </ul>
                </div>
            </section>
            <footer>
                <div class='email'>
                    <p>Got a question about the recipe?</p>
                    <a href="mailto:recipes@groundnutmeg.com">recipes@groundnutmeg.com</a>
                </div>
            </footer>
        </div>
    </transition>
</template>

<script>
import axios from 'axios'
import { viewsMixin } from '@/mixins/views.js'
export default {
    name: 'Recipes',
    mixins: [ viewsMixin ],
    props: [
        'id'
    ],
    data () {
        return {
            imageSize: 960,
            recipe: {},
            loaded: false
        }
    },
    computed: {
        webp() {
            return '/assets/' + this.id + '/' + this.id + '-' + this.imageSize + '.webp'
        },
        jpeg() {
            return '/assets/' + this.id + '/' + this.id + '-' + this.imageSize + '.jpeg'
        }
    },
    created: function () {
        axios.get('/api/recipes/' + this.id)
            .then(response => {
                if (response.data) {
                    this.recipe = response.data.recipe
                    document.title = this.recipe.title
                    document.getElementsByTagName('meta')["description"].content = this.recipe.description
                    document.head.querySelector("script[type='application/ld+json']").textContent = JSON.stringify({
                        '@context': 'https://schema.org/',
                        '@type': 'Recipe',
                        name: this.recipe.title,
                        image: [
                            this.recipe.assets + this.recipe.id + '/' + this.recipe.id + '-' + '960' + '.jpeg'
                        ],
                        author: {
                            '@type': 'Person',
                            name: this.recipe.author
                        },
                        description: this.recipe.description,
                        keywords: this.recipe.tags.join(', '),
                        recipeIngredient: this.recipe.components.map(function (component) {
                            return component.ingredients
                        }).flat(1),
                        recipeYield: this.recipe.servings,
                        recipeInstructions: this.recipe.method.map(function (instruction) {
                            return {
                                '@type': 'HowToStep',
                                'text': instruction
                            }
                        })
                    })
                    this.loaded = true
                    axios.put('/api/views/' + this.id)
                }
            })
            .catch(error => {
                console.log(error);
                window.location.replace("/");
            })
    }
}
</script>

<style scoped>
@media (max-width: 450px) {
    .logo h1 {
        font-size: 2em;
    }
}
@media (min-width: 450px) {
    .logo h1 {
        font-size: 3em;
    }
}
.wrapper {
    margin-left: auto;
    margin-right: auto;
    max-width: 960px;
}
a {
    color: #00B4CC;
}
a:hover {
    text-decoration: none;
    opacity: 0.8;
}
.title {
    padding: 18px 12px 18px 12px;
    text-align: left;
    font-weight: 800;
    font-size: 0.8em;
    letter-spacing: 0.2rem;
}
.details {
    height: 20px;
    margin: 0px 12px 12px 12px;
    position: relative;
}
.author {
    position: absolute;
    left: 0px;
    bottom: 0px;
    color: #555555;
    font-size: 1em;
}
.author img {
    height: 20px;
    margin-top: -5px;
    margin-left: -2px;
    padding-right: 10px;
    opacity: 0.3;
}
.views {
    position: absolute;
    right: 0px;
    bottom: 0px;
    color: #666666;
    font-size: 0.8em;
}
.story {
    padding: 20px 12px 20px 12px;
    text-align: justify;
    font-size: 1em;
}
.image {
    max-height: 440px;
    overflow: hidden;
}
.image img {
    width: 100%;
}
.ingredients {
    background-color: #333333;
    color: #f5f5f5;
    padding: 20px 12px 20px 12px;
    text-align: left;
}
dl {
    overflow: hidden;
    padding: 0;
    margin: 0
}
dt {
    float: left;
    width: 70%;
    font-weight: 200;
    font-size: 0.9em;
}
dd {
    float: right;
    width: 30%;
    padding-left: 20px;
    font-size: 0.9em;
}
.heading {
    letter-spacing: 0.1em;
    font-size: 1.4em;
    color: #00B4CC;
}
.component {
    font-weight: 800;
    padding-top: 15px;
    padding-bottom: 5px;
    color: #f5f5f5;
}
.method {
    padding: 12px;
    text-align: left;
    color: #333333;
}
.ingredient-list {
    padding-top: 12px;
    padding-bottom: 12px;
    text-align: justify;
    list-style-type: disc;
}
.steps {
    padding-top: 12px;
    padding-bottom: 12px;
    text-align: justify;
    list-style-type: decimal;
}
li {
    margin: 0 0 12px 0;
}
ul {
    padding-left: 18px;
    margin-bottom: 0px;
}
.email {
    background-color: #333333;
    padding-top: 24px;
    padding-bottom: 24px;
    text-align: center;
}
.email a {
    color: #00B4CC;
}
.email p {
    margin: 0px;
    color: #f5f5f5;
}
.email a:hover {
    text-decoration: none;
    opacity: 0.8;
}
.fade-enter-active {
    transition: opacity 300ms ease-in-out;
}
.fade-enter-to {
    opacity: 1;
}
.fade-enter {
    opacity: 0;
}
</style>